import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { SubscriptionItem } from 'src/features/subscriptionItems/utils/types';
import { SubscriptionItemFormSchemaValues } from 'src/features/subscriptionItems/utils/formSchema';

const RESOURCE = '/subscriptions/subscription/:subscriptionId/subscription-item/:itemId/';

type MutationFnType = typeof mutationFn;

interface DTO extends SubscriptionItemFormSchemaValues {
    itemId: string;
    subscriptionId: string;
}
const mutationFn = ({ subscriptionId, itemId, ...data }: DTO): Promise<SubscriptionItem> => {
    return axios.put(formatResourcePath(RESOURCE, { subscriptionId, itemId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateSubscriptionItem };
